import React from 'react';
import { Briefcase, MapPin, Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { experience } from '../mock';

const Experience = ({ isVisible }) => {
  return (
    <section id="experience" data-section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            Professional Experience
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-12"></div>

          <div className="max-w-5xl mx-auto">
            <div className="relative">
              {/* Timeline line */}
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-blue-300"></div>

              {experience.map((job, index) => (
                <div
                  key={job.id}
                  className={`relative mb-12 ${
                    index % 2 === 0 ? 'md:pr-1/2' : 'md:pl-1/2 md:ml-auto'
                  }`}
                  style={{
                    transitionDelay: `${index * 100}ms`
                  }}
                >
                  {/* Timeline dot */}
                  <div className="hidden md:block absolute top-6 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-700 rounded-full border-4 border-white z-10"></div>

                  <Card className="border-2 border-slate-200 hover:border-blue-700 hover:shadow-xl transition-all duration-300">
                    <CardHeader>
                      <div className="flex items-start justify-between mb-2">
                        <div className="flex-1">
                          <CardTitle className="text-xl text-blue-900 mb-2">
                            {job.position}
                          </CardTitle>
                          <div className="flex flex-wrap items-center gap-3 text-slate-600 mb-2">
                            <div className="flex items-center gap-1">
                              <Briefcase size={16} className="text-blue-700" />
                              <span className="font-semibold">{job.company}</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <MapPin size={16} className="text-blue-700" />
                              <span>{job.location}</span>
                            </div>
                          </div>
                          <div className="flex items-center gap-1 text-slate-500">
                            <Calendar size={16} className="text-blue-700" />
                            <span className="text-sm">{job.period}</span>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-slate-700 mb-4">{job.description}</p>
                      <ul className="space-y-2">
                        {job.responsibilities.map((resp, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-slate-600">
                            <span className="text-blue-700 mt-1">•</span>
                            <span>{resp}</span>
                          </li>
                        ))}
                      </ul>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;